export const AVAILABLE_SIZES = {
  small: 128,
  medium: 256,
  large: 512
};